import {
    type CompRef,
    type OverrideOrDefaultData,
    type Pointer,
    type SerializedCompStructure,
    type SingleLayoutData,
    SYSTEM_CONTAINER_TYPE
} from '@wix/document-services-types'
import type {CreateExtArgs} from '@wix/document-manager-core'
import type {ComponentsExtensionAPI} from '../../components/components'
import type {InnerElementsExtensionAPI} from '../innerElements'
import {EVENTS, type SlotsExtensionAPI} from '../../slots'

const defaultLayout: Partial<SingleLayoutData> = {
    containerLayout: {
        type: 'GridContainerLayout',
        rows: [
            {
                type: 'MinMaxSize',
                min: {
                    type: 'maxContent'
                },
                max: {
                    type: 'percentage',
                    value: 100
                }
            }
        ],
        columns: [
            {
                type: 'MinMaxSize',
                min: {
                    type: 'px',
                    value: 0
                },
                max: {
                    type: 'fr',
                    value: 1
                }
            }
        ]
    },
    spx: {
        refWidth: 1280,
        resolverType: 'scale'
    },
    componentLayout: {},
    // @ts-ignore
    itemLayout: {},
    type: 'SingleLayoutData'
}

const systemContainerDefinition: SerializedCompStructure = {
    componentType: SYSTEM_CONTAINER_TYPE,
    layouts: defaultLayout
}

export const populateSlotWithSystemContainer = (
    createExtArgs: CreateExtArgs,
    componentRef: Pointer,
    slotName: string,
    container: OverrideOrDefaultData,
    componentDefinition: SerializedCompStructure = systemContainerDefinition
): void => {
    const {extensionAPI, coreConfig, eventEmitter} = createExtArgs
    const {experimentInstance} = coreConfig
    const {components} = extensionAPI as ComponentsExtensionAPI
    const {innerElements} = extensionAPI as InnerElementsExtensionAPI
    const {slots} = extensionAPI as SlotsExtensionAPI
    const {path, nestedDataPath} = container
    const componentToAddPointer = components.getComponentToAddRef()

    if (path) {
        innerElements.setInnerElementSlots(
            componentToAddPointer,
            componentRef as CompRef,
            path,
            slotName,
            componentDefinition,
            nestedDataPath ?? []
        )
    } else if (experimentInstance.isOpen('dm_supportAddComponentV2InPopulate')) {
        slots.populate(
            componentRef as CompRef,
            slotName,
            componentDefinition,
            componentToAddPointer,
            undefined,
            nestedDataPath ?? []
        )
    } else {
        //TODO: should always add component via addComponentV2Internal even if the experiment is closed
        const ownerOfComponentInSlot = slots.getOwnerOfComponentInSlot(componentRef as CompRef)
        components.addComponentV2Internal(componentToAddPointer, ownerOfComponentInSlot, componentDefinition)
        const hostCompDefinition = slots.getCompDefinition(componentRef as CompRef)
        const slotsDataType = hostCompDefinition.slotsDataType ?? hostCompDefinition?.builderTypes?.slots

        if (experimentInstance.isOpen('dm_refactorStaticSlotToDynamic')) {
            const slotGuid = slots.updateSlotInData(componentToAddPointer, slotName, nestedDataPath ?? [])
            slots.updateSlot(componentRef as CompRef, slotGuid, componentToAddPointer, slotsDataType)
        } else {
            slots.updateSlot(componentRef as CompRef, slotName, componentToAddPointer, slotsDataType)
        }

        eventEmitter.emit(EVENTS.SLOTS.AFTER_POPULATE, componentRef, ownerOfComponentInSlot, componentToAddPointer)
    }
}
